import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';

import { ApiError, AuthService, BaseForm, BaseFormService, MessageService } from '../../../core';

import { Regiao } from '../regiao';
import { RegiaoCrudHttpService } from '../services';
import { RegiaoCidadeComponent } from '../cidade';
import { Estado, EstadoCrudHttpService } from '../../estado';
import { RegiaoRepresentanteComponent } from '../representante';

@Component({
    selector: 'sgt-regiao-form',
    templateUrl: './regiao-form.component.html',
    styleUrls: ['./regiao-form.component.less']
})
export class RegiaoFormComponent implements BaseForm<Regiao>, OnInit {
    entity: Regiao;
    editMode: boolean;
    @ViewChild('form') form: NgForm;

    @ViewChild('regiaoCidadeCadastro') regiaoCidadeCadastro: RegiaoCidadeComponent;
    @ViewChild('regiaoRepresentanteCadastro') regiaoRepresentanteCadastro: RegiaoRepresentanteComponent;

    estados: Estado[];

    constructor(private activatedRoute: ActivatedRoute,
                private authService: AuthService,
                private messageService: MessageService,
                private baseFormService: BaseFormService,
                private regiaoCrudHttpService: RegiaoCrudHttpService,
                private estadoCrudHttpService: EstadoCrudHttpService) { }

    ngOnInit() {
        this.baseFormService.getIdParam(this.activatedRoute).then(id => {
            if (!id) {
                this.insert();
            } else {
                this.edit(id);
            }
        });

        this.searchEstados();
    }

    private searchEstados() {
        this.estadoCrudHttpService.search()
            .subscribe(
                entities => this.estados = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os estados', error)
            );
    }

    load(id: number) {
        this.regiaoCrudHttpService.load(id)
            .subscribe(
                entity => this.entity = entity,
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar a região', error);
                    this.cancel();
                }
            );
    }

    insert() {
        this.editMode = false;
        this.entity = new Regiao();
        this.entity.idEmpresa = this.authService.getIdEmpresa();
    }

    edit(id: number) {
        this.editMode = true;
        this.load(id);
    }

     /** Valida se pode realizar o save */
    private validateSave(): boolean {
        // Cidades
        if (!this.regiaoCidadeCadastro.isValid()) {
            this.baseFormService.showTabForm('#tabCidades');
            return false;
        }
        // Representantes
        if (!this.regiaoRepresentanteCadastro.isValid()) {
            this.baseFormService.showTabForm('#tabPrincipal');
            return false;
        }

        return true;
    }

    private beforeSave() {
        // Cidades
        this.regiaoCidadeCadastro.resolve();
    }


    save() {
        if (this.validateSave()) {
            this.beforeSave();
            this.baseFormService.save<Regiao>(this.entity, this.form, this.editMode, this.regiaoCrudHttpService)
                .then(entity => {
                    this.messageService.success('', 'Região salva com sucesso');
                    this.afterSave(entity);
                })
                .catch(error => {});
        }
    }

    afterSave(entity: Regiao) {
        this.cancel();
    }

    cancel() {
        this.baseFormService.cancel(this.activatedRoute);
    }
}
